module.exports = __webpack_public_path__ + "img/20-image-1@2x.1977f2f9.png";